<template>
    <div class="components-container">
        <!-- 列表区域 -->
        <el-table :data="tableData" v-loading.body="tableLoading"
            element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
            :height="mainTableHeight" ref="mainTable" :rules="rules">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="课程类型" prop="coursePropertiesName" align="center"></el-table-column>
            <el-table-column label="占比" width="110" align="center">
                <template slot-scope="scope">
                    <span>
                        <div style="">{{ scope.row.percent }}</div>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="数量" prop="jjKcmc" width="110" align="center">
                <!-- <el-table-column label="统计结果" width="110" align="center"> -->
                    <template slot-scope="scope">
                        <span>
                            <div style="">{{ scope.row.jjKcmc }}</div>
                        </span>
                    </template>
                <!-- </el-table-column>
                <el-table-column label="最终统计结果" width="110" align="center">
                    <template slot-scope="scope">
                        <span>
                            <el-input-number v-model="scope.row.number"
                                v-show="scope.row.courseTypeName=='06'"
                                style="width: 70px;"
                                :controls="false"
                                size="mini"
                                :min="0"
                            ></el-input-number>
                        </span>
                    </template>
                </el-table-column> -->
            </el-table-column>
            <el-table-column label="学分" prop="jjXf" width="110" align="center" :formatter="xfFormatter">
                <!-- <el-table-column label="统计结果" width="110" align="center"> -->
                    <template slot-scope="scope">
                        <span>
                            <div>{{ xfFormatter(scope.row) }}</div>
                        </span>
                    </template>
                <!-- </el-table-column>
                <el-table-column label="最终统计结果" width="110" align="center">
                    <template slot-scope="scope">
                        <span>
                            <el-input-number v-model="scope.row.credit"
                                v-show="scope.row.courseTypeName=='06'"
                                style="width: 70px;"
                                :controls="false"
                                size="mini"
                                :min="0"
                            ></el-input-number>
                        </span>
                    </template>
                </el-table-column> -->
            </el-table-column>
            <el-table-column label="总学时" prop="jjZxs" width="110" align="center" :formatter="zxsFormatter">
                <!-- <el-table-column label="统计结果" width="110" align="center"> -->
                    <template slot-scope="scope">
                        <span>
                            <div>{{ zxsFormatter(scope.row) }}</div>
                        </span>
                    </template>
                <!-- </el-table-column>
                <el-table-column label="最终统计结果" width="110" align="center">
                    <template slot-scope="scope">
                        <span>
                            <el-input-number v-model="scope.row.totalhour"
                                v-show="scope.row.courseTypeName=='06'"
                                style="width: 70px;"
                                :controls="false"
                                size="mini"
                                :min="0"
                            ></el-input-number>
                        </span>
                    </template>
                </el-table-column> -->
            </el-table-column>
        </el-table>
        <!-- <div style="margin-top:20px; float:right;">
            <el-button type="primary" @click="saveSubtotal">保存</el-button>
        </div> -->
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";

    export default {
        props: ['listHeight','ksnf','zydm','xz'],
        data() {
            return {
                //查询列表数据
                queryForm: {
                    qxxn: this.ksnf,
                    zydm: this.zydm,
                    xz: this.xz,
                },
                semesterNumName: ["第一学期", "第二学期", "第三学期", "第四学期", "第五学期", "第六学期", "第七学期", "第八学期", "第九学期", "第十学期"],
                //表数据
                tableData: [],
                tableLoading: true,
                mainTableHeight: 560,
                loadingMask: null,
                rules: {//表单验证
                    number: [{required: true, message: "请选择课程类型",trigger: ["blur","change"]}],
                    credit: [{required: true, message: "请选择课程",trigger: ["blur","change"]}],
                    totalhour: [{required: true, message: "请选择是否教学选修课",trigger: ["blur","change"]}],
                },
            }
        },
        mounted() {
            this.queryList();

            this.$nextTick().then(() => {
                if(this.listHeight){
                    this.mainTableHeight = this.listHeight;
                }else{
                    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                    //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                    this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
                    // 监听窗口大小变化
                    let self = this;
                    window.onresize = function() {
                        self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                    };
                }
            });
        },
        methods: {
            queryList() {
                this.tableLoading = true;

                this.$api.teachingManage.teachingScheme.queryProgressTypeStatistics({
                    data: this.queryForm,
                }).then((res) => {
                    this.tableData = res.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    showNotify('错误', error, 'error', 3000);
                });
            },
            closeDialog(){
                this.$emit("closeProgressTypeDialog");
            },
            xfFormatter(row){
                if(row.jjXf.indexOf(".")>-1){
                    let num = row.jjXf.split(".");
                    if(parseInt(num[1],10)==0){
                        return num[0];
                    }else{
                        return row.jjXf;
                    }
                }else{
                    return row.jjXf;
                }
            },
            zxsFormatter(row){
                if(row.jjZxs.indexOf(".")>-1){
                    let num = row.jjZxs.split(".");
                    if(parseInt(num[1],10)==0){
                        return num[0];
                    }else{
                        return row.jjZxs;
                    }
                }else{
                    return row.jjZxs;
                }
            },
            formatterNumShow(str) {
                if (str == "0") str = "";

                return str;
            },
            saveSubtotal(){
                for(let i=0;i<this.tableData.length;i++){
                    if(this.tableData[i].courseTypeName=="06"){
                        if((this.tableData[i].number+"")=="" || (this.tableData[i].credit+"")=="" || (this.tableData[i].totalhour+"")==""){
                            this.$message({
                                title: '提示',
                                message: '最终统计结果不能为空！',
                                type: 'warning',
                                duration: 2000,
                            });
                            return;
                        }
                    }
                }

                this.showLoadingMask("保存中，请稍候...");

                const paramMap = {
                    'qxxn': this.ksnf,
                    'zydm': this.zydm,
                    'xz': this.xz,
                    'tableData': JSON.stringify(this.tableData),
                }

                this.$api.teachingManage.teachingScheme.saveSubtotal({
                    data: paramMap,
                }).then((response) => {
                    let state = response.data.data.state;
                    let msg = response.data.data.msg;

                    if (state == 'Success') {
                        this.$notify({
                            title: "成功",
                            message: msg ? msg : "保存成功",
                            type: "success",
                            duration: 1500,
                        });
                        this.queryList();
                        this.closeLoadingMask();
                    }else{
                        this.$notify({
                            title: "失败",
                            message: msg ? msg : '保存失败',
                            type: "error",
                            duration: 3000,
                        });
                        this.closeLoadingMask();
                    }
                }).catch((err) => {
                    showNotify('错误', err, 'error', 3000);
                    this.closeLoadingMask();
                });
            },
            /**显示loading**/
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            /**关闭loading**/
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
        }
    };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// progressType.vue?18e24107